




















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {SaleParams} from "../../params";
import {CommonStatus} from "@/enums/status";
import {Component, Watch} from "vue-property-decorator";
import debounce from "lodash/debounce";
import {SaleStore} from "@/modules/sale/store";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
@Component({
    name: "SaleSearch",
    components: {EmployeeSelector, EnumSelector, DistrictSelector, ProvinceSelector, MillisecondDatePicker}
})
export default class extends mixins(CommonMixin) {
    params = new SaleParams();
    CommonStatus = CommonStatus;
    EmployeeType = EmployeeType;
    
    @Watch("params", { deep: true })
    onchangeParams(val: any) {
        this.handleChangeParams(val);
    }
    
    handleChangeParams = debounce((val: any) => {
        const params = {...val, page: 1};
        SaleStore.updateParams(params);
        SaleStore.listSale(params);
    }, 500)
}
